import { render, staticRenderFns } from "./TopicSection.vue?vue&type=template&id=4974858a&scoped=true&"
import script from "./TopicSection.vue?vue&type=script&lang=js&"
export * from "./TopicSection.vue?vue&type=script&lang=js&"
import style0 from "./TopicSection.vue?vue&type=style&index=0&id=4974858a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4974858a",
  null
  
)

export default component.exports